var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CardLayout"},[(!_vm.isLoading)?_vm._t("default"):_vm._l((_vm.cardCount),function(c){return _c('BaseCard',{key:c,attrs:{"status":"loading"}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }